export const editMutations = <const>{
	NAHRADNI_SAZBA_TABULKOVA_POZICE_SELECT_MAPPER: 'NAHRADNI_SAZBA_TABULKOVA_POZICE_SELECT_MAPPER',
};
